import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const META = [
  { label: "Control", value: "Influence" },
  { label: "Sourcing", value: "Proprietary" },
  { label: "Horizon", value: "Patient" },
];

const IndustrialEquity = () => {
  return (
    <section
      data-testid={LANDING.industrialEquity}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
      style={{ background: "var(--kr-bg-2)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-6">
          <SectionHeading
            index="07"
            label="Opportunistic Industrial Equity"
            title={
              <>
                Control positions in
                <br />
                <span className="italic text-[var(--kr-gold)]">asset-rich</span>{" "}
                industrial businesses.
              </>
            }
          />
          <p className="mt-8 text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch]">
            The platform seeks to target control and influence equity in lower-
            and mid-market industrial platforms where tangible assets,
            contracted revenues and operating leverage are intended to support
            an institutional value-realisation thesis. Investments would be
            pursued selectively, with operating discipline, governance and
            clear exit alignment.
          </p>

          <dl className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            {META.map((m) => (
              <div key={m.label}>
                <dt className="font-mono-label text-[10px] text-[var(--kr-text-muted)] mb-2">
                  {m.label}
                </dt>
                <dd className="font-serif-display text-[var(--kr-text)] text-[1.4rem]">
                  {m.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[5/4] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1621697944804-d0a393f7e01a?auto=format&fit=crop&w=1600&q=80"
              alt="Industrial port logistics at dusk"
              className="w-full h-full object-cover"
              style={{ filter: "grayscale(95%) brightness(0.7) contrast(1.1)" }}
            />
            <div
              aria-hidden
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(135deg, rgba(10,13,18,0.55) 0%, transparent 45%, rgba(10,13,18,0.45) 100%)",
              }}
            />
            <div className="absolute top-6 left-6 right-6 flex items-center justify-between">
              <span className="font-mono-label text-[10px] text-[var(--kr-text)]">
                Asset-Backed
              </span>
              <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
                Industrial Equity
              </span>
            </div>
            {/* corner brackets */}
            <span className="absolute top-3 left-3 w-5 h-5 border-l border-t border-[var(--kr-gold)]/70" />
            <span className="absolute top-3 right-3 w-5 h-5 border-r border-t border-[var(--kr-gold)]/70" />
            <span className="absolute bottom-3 left-3 w-5 h-5 border-l border-b border-[var(--kr-gold)]/70" />
            <span className="absolute bottom-3 right-3 w-5 h-5 border-r border-b border-[var(--kr-gold)]/70" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrialEquity;
